// src/utils/emailService.js
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../config/firebase";

const functions              = getFunctions(app);
const sendConfirmation       = httpsCallable(functions, "sendBookingConfirmation");
const sendReschedule         = httpsCallable(functions, "sendRescheduleConfirmation");
const sendInvite             = httpsCallable(functions, "sendStaffInvite");
const sendStaffNotification  = httpsCallable(functions, "notifyStaffNewBooking");

export async function sendBookingConfirmation(booking, tenant, bookingId, manageUrl) {
  try {
    await sendConfirmation({ booking, tenant, bookingId, manageUrl });
    return { success: true };
  } catch (err) {
    console.error("Email failed:", err);
    return { success: false, error: err };
  }
}

export async function sendRescheduleConfirmation(booking, manageUrl) {
  try {
    await sendReschedule({ booking, manageUrl });
    return { success: true };
  } catch (err) {
    console.error("Reschedule email failed:", err);
    return { success: false };
  }
}

export async function sendStaffInviteEmail(tenantId, staffEmail, staffName, tenantName, inviteUrl) {
  try {
    await sendInvite({ tenantId, staffEmail, staffName, tenantName, inviteUrl });
    return { success: true };
  } catch (err) {
    console.error("Staff invite email failed:", err);
    return { success: false };
  }
}

export async function notifyStaffNewBooking(tenantId, staffEmail, booking, tenant) {
  try {
    await sendStaffNotification({ tenantId, staffEmail, booking, tenant });
    return { success: true };
  } catch (err) {
    console.error("Staff notification failed:", err);
    return { success: false };
  }
}
